import script from "./UtilsExpendeduria.vue?vue&type=script&setup=true&lang=ts"
export * from "./UtilsExpendeduria.vue?vue&type=script&setup=true&lang=ts"

import "./UtilsExpendeduria.vue?vue&type=style&index=0&id=5ef3fff3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef3fff3"]])

export default __exports__